var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_8330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38965 0.499997C7.02298 0.499997 5.76465 0.833331 4.61465 1.5C3.46465 2.16666 2.55632 3.075 1.88965 4.225C1.22298 5.375 0.889648 6.63333 0.889648 8C0.889648 9.36667 1.22298 10.625 1.88965 11.775C2.55632 12.925 3.46465 13.8333 4.61465 14.5C5.76465 15.1667 7.02298 15.5 8.38965 15.5C9.75632 15.5 11.0147 15.1667 12.1646 14.5C13.3147 13.8333 14.223 12.925 14.8897 11.775C15.5563 10.625 15.8897 9.36667 15.8897 8C15.8897 6.63333 15.5563 5.375 14.8897 4.225C14.223 3.075 13.3147 2.16666 12.1646 1.5C11.0147 0.833331 9.75632 0.499997 8.38965 0.499997ZM8.38965 14.25C7.25632 14.25 6.21465 13.9667 5.26465 13.4C4.31465 12.8333 3.55632 12.075 2.98965 11.125C2.42298 10.175 2.13965 9.13333 2.13965 8C2.13965 6.86666 2.42298 5.825 2.98965 4.875C3.55632 3.925 4.31465 3.16667 5.26465 2.6C6.21465 2.03333 7.25632 1.75 8.38965 1.75C9.52298 1.75 10.5646 2.03333 11.5147 2.6C12.4647 3.16667 13.223 3.925 13.7897 4.875C14.3563 5.825 14.6397 6.86666 14.6397 8C14.6397 9.13333 14.3563 10.175 13.7897 11.125C13.223 12.075 12.4647 12.8333 11.5147 13.4C10.5646 13.9667 9.52298 14.25 8.38965 14.25ZM8.38965 4.25C8.22298 4.25 8.07298 4.30833 7.93965 4.425C7.80632 4.54167 7.73965 4.68333 7.73965 4.85V7.6L5.63965 8.9C5.50632 9 5.42298 9.13333 5.38965 9.3C5.35632 9.46667 5.38132 9.625 5.46465 9.775C5.54798 9.925 5.67298 10.0167 5.83965 10.05C6.00632 10.0833 6.17298 10.05 6.33965 9.95L8.73965 8.45C8.93965 8.31667 9.03965 8.13333 9.03965 7.9V4.85C9.03965 4.68333 8.97298 4.54167 8.83965 4.425C8.70632 4.30833 8.55632 4.25 8.38965 4.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_8330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.889648 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0e7cd4ec0e9bd546f104dfa9334b2f73.svg";
export { ForwardRef as ReactComponent };